import { useState } from 'react';
import type { FormEvent } from 'react';
import { api, ApiError } from '../lib/api';

export function Login({ onLogin }: { onLogin: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await api('/api/auth/login', { method: 'POST', json: { email, password } });
      onLogin();
    } catch (ex) {
      if (ex instanceof ApiError && ex.status === 401) setErr('Invalid email or password.');
      else if (ex instanceof ApiError && ex.status === 403) setErr('Your account is not a member of any workspace yet.');
      else setErr('Sign-in failed. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="brand">
          <div className="brand-mark">PX</div>
          <div className="brand-text">
            <div className="brand-title">PRAXIS</div>
            <div className="brand-sub">Market &amp; Opportunity Intelligence</div>
          </div>
        </div>
        <div className="field">
          <label htmlFor="email">Email</label>
          <input id="email" className="input" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="password">Password</label>
          <input id="password" className="input" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <button className="primary-btn" type="submit" disabled={busy} style={{ width: '100%', justifyContent: 'center' }}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        {err && <div className="error-text">{err}</div>}
      </form>
    </div>
  );
}
